import H from 'skypager-helper'

export const Helper = H 
export const attach = Helper.attach

export default Helper

const req = require.context('./helpers', false, /\.js$/)

Helper.registry.add(req)


// WEBPACK FOOTER //
// ./src/helper.js